import type { LogisticOperatorsFilter } from '../models';
import type { LogisticOperatorStatus } from '../enums';

export type ResolvedLogisticOperatorsQuery =
  | { kind: 'contradictory' }
  | { kind: 'byId'; logisticOperatorId: string }
  | {
      kind: 'paginatedList';
      name?: string;
      businessName?: string;
      status?: LogisticOperatorStatus;
    };

export function resolveLogisticOperatorsListQuery(
  filters: LogisticOperatorsFilter | undefined
): ResolvedLogisticOperatorsQuery {
  if (!filters) {
    return { kind: 'paginatedList' };
  }

  const idName = filters.selectedOperatorIdFromName?.trim() ?? '';
  const idBusiness = filters.selectedOperatorIdFromBusiness?.trim() ?? '';

  if (idName.length > 0 && idBusiness.length > 0 && idName !== idBusiness) {
    return { kind: 'contradictory' };
  }

  const resolvedId = idName || idBusiness;
  if (resolvedId.length > 0) {
    return { kind: 'byId', logisticOperatorId: resolvedId };
  }

  const name = filters.name?.trim();
  const businessName = filters.businessName?.trim();

  return {
    kind: 'paginatedList',
    ...(name && name.length > 0 ? { name } : {}),
    ...(businessName && businessName.length > 0 ? { businessName } : {}),
    ...(filters.status ? { status: filters.status } : {}),
  };
}
